import { render, staticRenderFns } from "./Artefact.vue?vue&type=template&id=2df9e79d&scoped=true&"
import script from "./Artefact.vue?vue&type=script&lang=js&"
export * from "./Artefact.vue?vue&type=script&lang=js&"
import style0 from "./Artefact.vue?vue&type=style&index=0&id=2df9e79d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df9e79d",
  null
  
)

export default component.exports